import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-hero-section',
  templateUrl: './hero-section.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./hero-section.component.scss']
})
export class HeroSectionComponent implements OnInit {
  @Input() header: string;
  @Input() description:string;
  @Input() joinChat:boolean;
  @Input() imagePath:string;
  @Input() hasBtn:boolean;
  @Input() routerButton:string;
  @Input() buttonText:string;
  @Input() isKsaImg:boolean;
  @Input() logoPath:string;
  @Input() isProductLogo:boolean;
  @Input() isProductGRCPage:boolean;
  constructor() { }


  ngOnInit(): void {

  }

}
